module.exports = __webpack_public_path__ + "static/media/LabourTeq_Logo_Secondary.15839a70.svg";